import { render } from "./WorkstreamsView.vue?vue&type=template&id=055d547a&scoped=true"
import script from "./WorkstreamsView.vue?vue&type=script&lang=js"
export * from "./WorkstreamsView.vue?vue&type=script&lang=js"

import "./WorkstreamsView.vue?vue&type=style&index=0&id=055d547a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055d547a"]])

export default __exports__